import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItemLink } from '../components/item/NavItem';
import styles from './nav_customer_button.module.scss';

export function NavCustomerButton() {
  return (
    <NavItemLink className={styles.container} href="/avis" source="header">
      <FormattedMessage id="navigation/customers/NavCustomerButton.tsx/1" />
    </NavItemLink>
  );
}
